/* eslint-disable react/destructuring-assignment */
import * as React from "react";

/**
 * Two interlocking rings — the merge glyph on the "Merged Records" and
 * "Opportunity Merged" timeline entries.
 *
 * The source SVG wrapped the path in a full-canvas `clipPath`, which clipped
 * nothing (the rect covers the whole 16×16 viewBox). It is dropped here rather
 * than carried: both merge events can appear in one thread, and a duplicated
 * `clipPath` id is invalid markup for no benefit.
 */
const MergedRecordsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "#334155"}
      d="M10.914 5.08528C10.7477 4.18972 10.34 3.3566 9.73478 2.67588C9.12957 1.99515 8.34991 1.49267 7.47998 1.22271C6.61005 0.95274 5.6829 0.925538 4.79863 1.14404C3.91437 1.36254 3.10659 1.81844 2.46251 2.46251C1.81844 3.10659 1.36254 3.91437 1.14404 4.79863C0.925538 5.6829 0.95274 6.61005 1.22271 7.47998C1.49267 8.34991 1.99515 9.12957 2.67588 9.73478C3.3566 10.34 4.18972 10.7477 5.08528 10.914C5.25156 11.8096 5.65931 12.6427 6.26452 13.3234C6.86973 14.0042 7.64939 14.5066 8.51932 14.7766C9.38925 15.0466 10.3164 15.0738 11.2007 14.8553C12.0849 14.6368 12.8927 14.1809 13.5368 13.5368C14.1809 12.8927 14.6368 12.0849 14.8553 11.2007C15.0738 10.3164 15.0466 9.38925 14.7766 8.51932C14.5066 7.64939 14.0042 6.86973 13.3234 6.26452C12.6427 5.65931 11.8096 5.25156 10.914 5.08528ZM1.99965 5.99965C1.99773 5.0247 2.35195 4.08262 2.99575 3.35045C3.63954 2.61829 4.52857 2.14646 5.49575 2.02364C6.46294 1.90083 7.44168 2.13548 8.24803 2.68349C9.05439 3.23151 9.63283 4.05516 9.87465 4.99965C8.59264 5.03334 7.37247 5.55787 6.46593 6.46499C5.55939 7.37211 5.03564 8.59262 5.00278 9.87465C4.14382 9.65239 3.38293 9.15132 2.83943 8.45003C2.29593 7.74874 2.00056 6.88689 1.99965 5.99965ZM9.99965 13.9997C9.11282 13.9989 8.25129 13.704 7.55006 13.1611C6.84882 12.6182 6.3475 11.858 6.12465 10.9997C7.40721 10.9667 8.62816 10.4426 9.53537 9.53537C10.4426 8.62816 10.9667 7.40721 10.9997 6.12465C11.9441 6.36647 12.7678 6.94491 13.3158 7.75127C13.8638 8.55762 14.0985 9.53636 13.9757 10.5035C13.8528 11.4707 13.381 12.3598 12.6488 13.0036C11.9167 13.6473 10.9746 14.0016 9.99965 13.9997Z"
    />
  </svg>
);

export default MergedRecordsIcon;
